/**
 * Relative "time ago" label.
 *
 * The logic is lifted VERBATIM from the original local `timeAgo` helper in
 * `src/pages/settings/DataManagement.tsx` (the integration step later switches
 * that page to import this shared util). Keep the behaviour byte-for-byte
 * identical — several surfaces depend on the exact strings ("Never", "Just now",
 * "5m ago", "3h ago", "2d ago").
 */
export function timeAgo(dateStr: string | null): string {
  if (!dateStr) return "Never";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
